export default __webpack_public_path__ + "static/media/Background 5_00027.c0c501d1.png";